import { LabText } from "../../components/Lab/LabText"
import "./LabPage.scss"

export const LabPage = () =>{
  return (
    <LabText />
  )
}